import { ITruongActionTypes, eTruongActionTypeIds } from "../../action-types/category/ITruongActionType";
import { ITruongReducer } from "../../reducer-model/category/ITruongReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: ITruongReducer = {
    status: eReducerStatusBase.is_not_initialization,
    truongs: []
}
export const truongReducer = (state: ITruongReducer=iniState, action: ITruongActionTypes): ITruongReducer => {
    switch (action.type) {
        case eTruongActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case eTruongActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                truongs: action.payload
            }
        case eTruongActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return {
                ...state
            };
    }
}